import { useEffect } from "react";
import Evaluation from "./Evaluation";
import Selection from "./Selection";
import Fellowshipgift from "./Fellowshipgift";
import Fellow_Video from "./Fellow_Vedio";
export default function Fellowship() {
  const cardData = [
    { title: "Skillsphere Report" },
    { title: "Completion Certificate" },
    { title: "Enrolled to Clubs" },
  ];
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page
      }, []);
  
  return (
    <div>
        <style jsx global>{`
        @keyframes itemRise {
          0% { transform: translateY(0); }
          100% { transform: translateY(-5px); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
        }
        @keyframes borderGlow {
          0%, 100% { box-shadow: 0 0 5px rgba(53, 114, 255, 0.5); }
          50% { box-shadow: 0 0 15px rgba(53, 114, 255, 0.8); }
        }
        @keyframes iconPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.2); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        .floating-dot {
          position: absolute;
          border-radius: 50%;
          animation: float ease-in-out infinite;
          z-index: 0;
        }
        .dots-container {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          overflow: hidden;
          z-index: 0;
        }
      `}</style>
      <div className="dots-container">
        {[5, 15, 25, 35, 45, 55, 65, 75, 85, 95, 10, 20, 30, 40, 50, 60, 70, 80, 90].map((top, i) => (
          <div
            key={i}
            className="floating-dot"
            style={{
              top: `${top}%`,
              left: `${Math.random() * 100}%`,
              width: `${6 + (i % 5)}px`,
              height: `${6 + (i % 5)}px`,
              backgroundColor: ['#3572FF', '#06AED4', '#EC7D4E', '#9F7AEA', '#7F56D9', '#F59E0B'][i % 6],
              animationDelay: `${i * 0.2}s`,
              animationDuration: `${4 + (i % 6)}s`,
              opacity: 0.7
            }}
          />
        ))}
      </div>
      <div className="w-full min-h-screen bg-gradient-to-b from-blue-200 via-purple-200 to-white bg-cover bg-top bg-no-repeat flex flex-col justify-center items-center md:pb-10">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 px-4 py-10">
          <div className="max-w-md text-center md:text-left">
            <div className="flex justify-center md:justify-normal items-center text-center relative gap-2 mb-4">
              <img
                src="https://dbqa318yoj3nn.cloudfront.net/gradcap.png"
                alt="Graduation Cap"
                className="hidden md:block md:w-13 md:h-13 absolute left-[-35%] top-[-150%] text-blue-600"
              />
              <h1
                className="text-4xl md:text-6xl text-gray-800"
                style={{ fontFamily: "Montserrat" }}
              >
                Fellowship
              </h1>
            </div>
            <h2 className="text-7xl font-bold text-blue-600 mb-4 font-ADLaMDisplay"  style={{ fontFamily: "Montserrat" }}>
              Program
            </h2>
            <p
              className="w-[90%] ml-4 md:ml-0"
              style={{ fontFamily: "Montserrat" }}
            >
              This opportunity will be given to all the students of Simplifying
              Skills who want to become entrepreneurs and make a societal
              impact.
            </p>
          </div>

          <div className="mt-6 md:mt-0 md:ml-8">
            <img
              src="https://dbqa318yoj3nn.cloudfront.net/graduationimage.png"
              alt="Graduating Student"
              className="w-[500px] rounded-lg"
            />
          </div>
        </div>

        <div className="flex flex-col items-center justify-center gap-6 px-4 py-8 md:px-8">
          <div className="flex justify-center mb-8">
            <div className="bg-gradient-to-br from-purple-600 via-blue-500 to-indigo-500 text-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 h-40 w-[280px] transition-transform hover:scale-105">
              <div className="bg-white text-blue-600 rounded-md p-2 mb-4">
                <img src="https://dbqa318yoj3nn.cloudfront.net/Placeholder.png" className="w-6 h-6" />
              </div>
              <h2
                className="text-lg w-[60%] font-semibold tracking-widest text-center uppercase"
                style={{ fontFamily: "Montserrat" }}
              >
                Skillsphere Report
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-14 md:gap-[290px]">
            {cardData.slice(1).map((card, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-purple-300 to-blue-400 text-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 h-40 w-[280px] transition-transform hover:scale-105"
              >
                <div className="bg-white text-blue-600 rounded-md p-2 mt-10">
                  <img alt="Graduation emoji" src="https://dbqa318yoj3nn.cloudfront.net/Placeholder.png" className="w-6 h-6" />
                </div>
                <h2
                  className="text-lg w-[60%] mt-3 mb-8 font-semibold tracking-widest text-center uppercase"
                  style={{ fontFamily: "Montserrat" }}
                >
                  {card.title}
                </h2>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div><Fellow_Video/></div> 
      <Evaluation />
      <Selection />
      <Fellowshipgift/>
    </div>
  );
}
